import dayjs from "dayjs";
import { TimeEvent } from "../types/employee";

type DailyTotals = {
    [date: string]: number;
}

const normalizeEventType = (value: unknown) => {
    if (typeof value !== "string") return "";
    return value.trim().toLowerCase().replace(/[\s-]+/g, "_");
};

//this function takes in an array of time events for a given day and calculates the total minutes worked
export function calculateWorkedMinutesWithOvernights(events: TimeEvent[]): DailyTotals {
        // Group events by day
        const eventsByDay: Record<string, TimeEvent[]> = {};

        for (const ev of events) {
            const day = dayjs(ev.timestamp.toDate()).format("YYYY-MM-DD");
            if (!eventsByDay[day]) eventsByDay[day] = [];
            eventsByDay[day].push(ev);
        }

        // Sort days in order
        const sortedDays = Object.keys(eventsByDay).sort();

        const dailyTotals: DailyTotals = {};

        for (let d = 0; d < sortedDays.length; d++) {
            const day = sortedDays[d];
            const dayEvents = eventsByDay[day].sort((a, b) => a.timestamp.toMillis() - b.timestamp.toMillis());

            if (!dailyTotals[day]) dailyTotals[day] = 0;

            let i = 0;
            while (i < dayEvents.length - 1) {
                const curr = dayEvents[i];
                const next = dayEvents[i + 1];
                const currType = normalizeEventType(curr.type);
                const nextType = normalizeEventType(next.type);

                if ((currType === "clock_in" || currType === "break_end") &&
                    (nextType === "clock_out" || nextType === "break_start")) {
                    const start = dayjs(curr.timestamp.toDate());
                    const end = dayjs(next.timestamp.toDate());

                    dailyTotals[day] += end.diff(start, "minute", true);
                    i += 2;
                } else {
                    i++;
                }
            }

            // Handle overnight detection
            const lastEvent = dayEvents[dayEvents.length - 1];
            const lastType = normalizeEventType(lastEvent?.type);
            const nextDay = sortedDays[d + 1];

            if (
                lastEvent &&
                (lastType === "clock_in" || lastType === "break_end") &&
                nextDay
            ) {
                const nextDayEvents = eventsByDay[nextDay].sort((a, b) => a.timestamp.toMillis() - b.timestamp.toMillis());
                const firstNextDayEvent = nextDayEvents[0];
                const firstNextType = normalizeEventType(firstNextDayEvent?.type);

                if (firstNextDayEvent && (firstNextType === "clock_out" || firstNextType === "break_start")) {
                    const start = dayjs(lastEvent.timestamp.toDate());
                    const end = dayjs(firstNextDayEvent.timestamp.toDate());

                    dailyTotals[day] += end.diff(start, "minute", true);
                }
            }
        }

        return dailyTotals;
    }
